export class GeoLoad {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.modelSection = modelSection ?? null;
        this.elevation = data.elevation ?? null;
        this.continuousUniformVerticalLoadP = data.continuousUniformVerticalLoadP ?? null;
        this.direction = data.direction ?? null;
        this.notes = data.notes ?? null;

    }

}
